module.exports = __webpack_public_path__ + "static/cineplexfrench-logo-1ea582775cf163188f89b6905a30061a.png";